import { createContext, useContext } from 'react';
import useExtNcUnreadCountsLogic from './useExtNcUnreadCountsLogic';

type ExtNcUnreadCountsLogic = ReturnType<typeof useExtNcUnreadCountsLogic>;

const extNcUnreadCountsContext = createContext<ExtNcUnreadCountsLogic | null>(null);

export const ExtNcUnreadCountsProvider = extNcUnreadCountsContext.Provider;

export const useExtNcUnreadCountsService = () => {
  const value = useContext(extNcUnreadCountsContext);

  if (!value) {
    throw new Error('Error, using useExtNcUnreadCountsService out of provider');
  }

  return value;
};
